import { Pipe, PipeTransform } from '@angular/core';

import { Role, RoleType } from '@lockton-apps/shared/interfaces';

@Pipe({
  name: 'roleDescription',
  standalone: true,
})
export class RoleDescriptionPipe implements PipeTransform {
  roleDescriptionMap = new Map<RoleType, string>([
    [Role.Administrator, 'Administrator'],
    [Role.LeadBroker, 'Lead Broker'],
    [Role.Broker, 'Broker'],
    [Role.Contact, 'Contact'],
  ]);

  backUpValue = 'No Role Found';

  transform(value: RoleType): string {
    return this.roleDescriptionMap.get(value) || this.backUpValue;
  }
}
